import { render } from "./BehaviourProgramData.vue?vue&type=template&id=41a127df"
import script from "./BehaviourProgramData.vue?vue&type=script&lang=js"
export * from "./BehaviourProgramData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__